import React from 'react';
import { connect } from 'dva';
import SkusEditDetail from 'components_business/SkusEdit/Index.js';
import { COMMODITY_PRICE } from 'utils/const.js';

@connect(({ SkusEdit }) => ({
  skusList: SkusEdit.skus.skusList,
  skusCombinationList: SkusEdit.skusCombinationList,
}))
export default class Skus extends React.Component {
  render() {
    const { skusList, skusCombinationList, type } = this.props;

    return (
      <SkusEditDetail
        skusList={skusList}
        combinationList={skusCombinationList}
        type={type}
        lowPrice={COMMODITY_PRICE.min}
        highPrice={COMMODITY_PRICE.max}
        parentSkusLength={10}
        childSkusLength={20}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Commodity/Modal/Skus.js